(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("miniOwm", [], factory);
	else if(typeof exports === 'object')
		exports["miniOwm"] = factory();
	else
		root["miniOwm"] = factory();
})(window, function() {
return 